/* eslint-disable no-mixed-spaces-and-tabs */
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Load Icons
import { defineElement } from 'lord-icon-element';
import lottie from 'lottie-web';

import { ProjectsRoutingModule } from './projects-routing.module';
import { ProjectsComponent } from './projects.component';
import { ProjectSidebarComponent } from './project-sidebar/project-sidebar.component';
import { ProjectContentComponent } from './project-content/project-content.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ProjectListItemComponent } from './project-sidebar/project-list-item/project-list-item.component';
import { ProjectConversationComponent } from './project-content/project-conversation/project-conversation.component';

import { NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { ProjectExamineeComponent } from './project-content/project-examinee/project-examinee.component';
import { ProjectTeamComponent } from './project-content/project-team/project-team.component';
import { ProjectQuestionnaireComponent } from './project-content/project-questionnaire/project-questionnaire.component';
import { CreateProjectQuestionnaireComponent } from './project-content/project-questionnaire/create-project-questionnaire/create-project-questionnaire.component';
import { PreviewQuestionnaireComponent } from './project-content/project-questionnaire/preview-questionnaire/preview-questionnaire.component';
import { ViewExamineeReportComponent } from './project-content/project-examinee/view-examinee-report/view-examinee-report.component';
import { ConversationPageComponent } from './project-content/project-conversation/conversation-page/conversation-page.component';
import { ProjectAssessmentComponent } from './project-content/project-assessment/project-assessment.component';
import { AssessmentPageComponent } from './project-content/project-assessment/assessment-page/assessment-page.component';
import { ViewAssessmentConversationComponent } from './project-content/project-assessment/assessment-page/view-assessment-conversation/view-assessment-conversation.component';

import { ViewAssessmentTeamComponent } from './project-content/project-assessment/assessment-page/view-assessment-team/view-assessment-team.component';

@NgModule({
  declarations: [
		ProjectsComponent,
  	ProjectSidebarComponent,
   	ProjectContentComponent,
    ProjectListItemComponent,
    ProjectConversationComponent,
    ProjectExamineeComponent,
    ProjectTeamComponent,
    ProjectQuestionnaireComponent,
    CreateProjectQuestionnaireComponent,
    PreviewQuestionnaireComponent,
    ViewExamineeReportComponent,
    ConversationPageComponent,
    ProjectAssessmentComponent,
    AssessmentPageComponent,
    ViewAssessmentConversationComponent,
    ViewAssessmentTeamComponent
	],
  imports: [
    CommonModule,
    ProjectsRoutingModule,
		SharedModule,
		NgbModule,
		NgbNavModule
  ],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ProjectsModule {
	constructor() {
    defineElement(lottie.loadAnimation);
  }
}
